define('SageDotCom/DataLayer/Events/expansionClick',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ExpansionClick() {
        EventBase.call(this); // inherit eventBase
        this.name = "expansion_click"; // overwrite name
    }

    ExpansionClick.prototype = Object.create(EventBase.prototype);

    ExpansionClick.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, direction, label) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "component",
            'event_action': this.getName()
        }

        if (scope) {
            var lbl = label || $(".panel-heading", scope).text() || $(scope).text() || $("a:first", scope).text() || "";
            var location = this.getLocation(scope);

            eventData = $.extend(eventData, {
                'event_label': this.cleanseString(lbl.trim()), // strip any html
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': direction || "",
                'event_name_level_3': "",
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new ExpansionClick();
});
